import React from "react";
import { useNavigate } from "react-router-dom";

// Custom.
import Layout from "containers/Layout/Layout";
import { EnhancedTable } from "@vocollege/components";
import {
  GET_EVENTS,
  DELETE_EVENT,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { EnhancedTableStatusCell } from "@vocollege/components";

export default function Events() {
  let navigate = useNavigate();

  const editItem = (id = "create") => {
    navigate(`/content/events/${id}`);
  };

  const getFilters = () => {
    return [
      {
        name: "status",
        label: I18n.get.form.labels.status,
        default: ["all"],
        values: [
          { label: I18n.get.actions.showAll, value: "all" },
          { label: I18n.get.status.published, value: "1" },
          { label: I18n.get.status.unpublished, value: "0" },
        ],
      },
    ];
  };

  return (
    <Layout>
      <EnhancedTable
        className="vo-global__top-bottom-space"
        enableSearch
        title={I18n.get.event.labels.events}
        operations={{
          category: "events",
          get: GET_EVENTS,
          delete: DELETE_EVENT,
        }}
        columns={[
          { title: "ID", field: "id", width: 90 },
          { title: I18n.get.form.labels.title, field: "title" },
          {
            title: I18n.get.form.labels.allday,
            field: "allday",
            render: (data) =>
              data.allday ? I18n.get.actions.yes : I18n.get.actions.no,
          },
          {
            title: I18n.get.form.labels.startdate,
            field: "start_date",
            render: (data) => data?.start_date,
          },
          {
            title: I18n.get.form.labels.starttime,
            field: "start_time",
            render: (data) => data?.start_time,
          },
          {
            title: I18n.get.misc.created_at,
            field: "created_at",
            width: 200,
          },
          {
            title: I18n.get.misc.updated_at,
            field: "updated_at",
            width: 200,
          },
          {
            title: I18n.get.form.labels.status,
            field: "status",
            width: 120,
            render: (data: any) => (
              <EnhancedTableStatusCell data={data.status} />
            ),
          },
        ]}
        addItem={editItem}
        editItem={editItem}
        orderBy="UPDATED_AT"
        order="DESC"
        filters={getFilters()}
      />
    </Layout>
  );
}
